<template>
  <router-view :key="$route.fullPath"/>
</template>

<script>
export default {
  methods: {
    async GetQuizes() {
      try {
        let res = await fetch("https://mfc.samgk.ru/quiz/quiz-api/").then(response => response.json())
        return res.quizes
      } catch (e) {
        console.log(e)
      }

      return []
    },
  },
}
</script>